import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getCollectionListbyWalletAddress } from '../../hooks/Collectionhook';
import CollectionCardPlaceholder from '../cards/CollectionCardPlaceholder';
import DynamicCollectionCard from './DynamicCardUI/DynamicCollectionCard';
import Pagination from '../Pagination';
import { listNFTs } from '../../hooks/NFTHook';

function Collection3(props) {
  // State variables
  const [collectionList, setCollectionList] = useState([]); // Holds the collection data
  const [pageCount, setPageCount] = useState(0); // Total number of pages for pagination
  const [currentPage, setCurrentPage] = useState(0); // Tracks the current page number
  const [hasMore, setHasMore] = useState(true); // Flag to indicate if more collections are available
  const [loading, setLoading] = useState(false); // Flag for showing loading state
  const [limit, setLimit] = useState(props.length); // Number of items per page

  const location = useLocation(); // Used to determine the current route/state
  const walletAddress = localStorage.getItem('WalletAddress'); // Fetch wallet address from localStorage

  // Fetch collections on component mount or when page/state changes
  useEffect(() => {
    const isUserView = location.state === 'user'; // Check if the view is user-specific
    fetchCollections(isUserView);
  }, [currentPage, location.state]);

  /**
   * Fetch collections based on the current page and whether it's a user-specific view.
   * @param {boolean} isUserView - Determines if collections are filtered by the user's wallet address.
   */
  const fetchCollections = async (isUserView) => {
    setLoading(true); // Start loading state
    const Params = {
      page: currentPage + 1, // Backend expects pages to start from 1
      limit: limit, // Fetch 9 collections per page
      sortBy: 'createdAt', // Sort collections by creation date
      isDraft: false,
      ...(isUserView && { ownerAddress: walletAddress }), // Filter by wallet address if in user view
    };

    try {
      console.log("step 1 => Params", Params);
      
      const data = await getCollectionListbyWalletAddress(Params); // Fetch collections from API
      console.log("step 2 => totalPages data", data);
      
      if (data.success) {
        const collectionsWithMarketData = await fetchMarketDataForCollections(data.data); // Fetch additional market data
        console.log("collectionsWithMarketData", collectionsWithMarketData);
     
        setCollectionList(collectionsWithMarketData); // Update the collection list
        setPageCount(data.totalPages); // Set the total page count for pagination
        setHasMore(data.total > 0); // Determine if there are collections to display
      } else {
        setHasMore(false); // No collections available
      }
    } catch (error) {
      console.error('Error fetching collections:', error);
      setHasMore(false);
    } finally {
      setLoading(false); // End loading state
    }
  };
console.log("pageCount", collectionList);

  /**
   * Fetch market data for each collection.
   * @param {Array} collections - List of collections to fetch market data for.
   * @returns {Array} Collections with market data added.
   */
  const fetchMarketDataForCollections = async (collections) => {
    const marketDataPromises = collections.map(async (collection) => {
      const marketData = await fetchMarketData(collection.contractAddress);
      console.log("marketData?.total", marketData?.total);
      
      return marketData?.total > 0 ? { ...collection, marketData } : null; // Add market data if available
    });

    const collectionsWithMarketData = await Promise.all(marketDataPromises); // Wait for all market data to resolve
    return collectionsWithMarketData.filter(Boolean); // Filter out collections without market data
  };

  /**
   * Fetch market data for a specific contract address.
   * @param {string} contractAddress - The contract address of the collection.
   * @returns {Object} Market data for the collection.
   */
  const fetchMarketData = async (contractAddress) => {
    const params = { page: 1, limit: 4, contractAddress, sortBy: 'createdAt' };
    const marketData = await listNFTs(params); // Fetch NFT market data
    console.log("marketData", marketData);
    
    return marketData.success ? marketData : { success: false, data: [] };
  };

  /**
   * Handle page change for pagination.
   * @param {Object} selectedItem - Selected page from the pagination component.
   */
  const handlePageChange = (selectedItem) => {
    setCurrentPage(selectedItem.selected); // Update current page
    setCollectionList([]); // Clear the previous collection data for smoother transitions
  };

  return (
    <div className="row justify-content-center mb-30_reset">
      {/* Header Section */}
      <div className="d-flex section__head space-x-20 justify-content-between align-items-center">
        <h2 className="section__title text-center">All Collections</h2>
        {props.viewAll && <Link to="/collections" className="btn btn-sm btn-dark">View All</Link>}
      </div>

      {/* Collection Cards or Loading State */}
      <div className="row">
        {loading ? (
          // Show placeholders during loading
          Array.from({ length: limit }).map((_, index) => (
            <div className="col-lg-4 col-sm-12" key={index}>
              <CollectionCardPlaceholder />
            </div>
          ))
        ) : collectionList.length > 0 ? (
          // Display fetched collections
          collectionList.map((collection, index) => (
            <div className="col-lg-4 col-md-6 col-sm-12 card-hover-effect" key={index}>
              <DynamicCollectionCard
                CollectionLink={`/collectionDetails/${collection.contractAddress}`}
                marketItem={collection.marketData?.data || []}
                ownerDetails={collection?.marketData?.data[0]?.currentOwner}
                collectionName={collection.name}
                collectionLogo={collection.logo}
                totalMarketItem={collection.marketData?.total || 0}
              />
            </div>
          ))
        ) : (
          // Show a message if no collections are available
          <h3>No collections available</h3>
        )}
      </div>

      {/* Pagination Component */}
      {props.market !== true && pageCount > 1 && (
        <Pagination pageCount={pageCount} onPageChange={handlePageChange} currentPage={currentPage} />
      )}
    </div>
  );
}

export default Collection3;
